import useUiStore from './useUiStore'
import shallow from 'zustand/shallow'

/**
 * Provides the 
 * @returns {{ boolean, function, boolean, function, boolean, function }} [showCurtain, setShowCurtain, showCurtainFilters, setShowCurtainFilters, skipCurtain, setSkipCurtain]
 */
export default function useCurtain() {
  return useUiStore(
    state => ({
      showCurtain: state.showCurtain,
      setShowCurtain: state.setShowCurtain,
      showCurtainFilters: state.showCurtainFilters,
      setShowCurtainFilters: state.setShowCurtainFilters,
      skipCurtain: state.skipCurtain,
      setSkipCurtain: state.setSkipCurtain
    }),
    shallow
  )
}
